import React from 'react'
import App from './App';

const Header = () => {
  return (
    <div className='headerHolder'>
      Play Quiz
      </div>
  )
}

export default Header